import React from "react";
import { connect } from 'react-redux';
import TextInput from '@zacousticrepo/grommet-v1-custom/components/TextInput';
import RadioButton from '@zacousticrepo/grommet-v1-custom/components/RadioButton';
//import FormControl from '@material-ui/core/FormControl/FormControl';
//import RadioGroup from '@material-ui/core/RadioGroup/RadioGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
//import Radio from '@material-ui/core/Radio/Radio';

const surveyFormTypes = {
    agent: 'agent',
    customer: 'customer',
    qa: 'qa'
}

class SurveyNameAndTypeGetter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            surveyFormType: surveyFormTypes.qa,
            surveyFormName: undefined
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeAndCreate = this.closeAndCreate.bind(this);
        this.selectSurveyFormType = this.selectSurveyFormType.bind(this);

        this.updateName = this.updateName.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    closeAndCreate() {
        const
            {
                onClose
            } = this.props;
        onClose(this.state.surveyFormName, this.state.surveyFormType);
    }

    updateName({ target }) {
        this.setState({ surveyFormName: target.value });
    }

    selectSurveyFormType(surveyFormType) {
        this.setState({ surveyFormType: surveyFormType });
    }

    render() {
        const
            {

            } = this.props;
        let textInput;
        let agentIsChecked = this.state.surveyFormType === surveyFormTypes.agent;
        let customerIsChecked = this.state.surveyFormType === surveyFormTypes.customer;
        let qaIsChecked = this.state.surveyFormType === surveyFormTypes.qa;
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-create-survey" ref={this.wrapperRef}>
                <div className="eighteen-regular-primary-color" >
                    Survey Name
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <TextInput
                        className="rectangle-18560"
                        id={"1"}
                        name={"min"}
                        onDOMChange={this.updateName}
                        value={textInput}
                    />
                </div>
                <div style={{ margin: '20px auto' }}>
                    <div className="eighteen-regular-primary-color " style={{ margin: '32px 0 16px 0' }}>Type</div>
                    <div className="radio-button-text">
                        <RadioButton id="qa" label='QA' checked={qaIsChecked}
                            onChange={() => this.selectSurveyFormType(surveyFormTypes.qa)} />
                        <RadioButton id="agent" label='Agent' checked={agentIsChecked}
                            onChange={() => this.selectSurveyFormType(surveyFormTypes.agent)} />
                        <RadioButton id="customer" label='Customer' checked={customerIsChecked}
                            onChange={() => this.selectSurveyFormType(surveyFormTypes.customer)} />
                    </div>
                    {/*
                        <div className="eighteen-regular-primary-color " style={{ margin: '32px 0 16px 0' }}>Type</div>
                        <div className="radio-button-text">
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={this.state.surveyFormType}
                                    onChange={this.selectSurveyFormType} >
                                    <FormControlLabel className="radio-button-text" value={surveyFormTypes.agent} control={< Radio />} label="Female" />
                                    <FormControlLabel className="radio-button-text" value={surveyFormTypes.qa} control={<Radio />} label="Male" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        */}
                </div>
                <div style={{ position: 'relative' }}>
                    <button className="create-survey-button" style={{ position: 'relative', margin: '0 auto' }}
                        onClick={this.closeAndCreate}>Create Survey</button>
                </div>
            </div>
        </div>);
    };
}

const select = state => ({});

export default connect(select)(SurveyNameAndTypeGetter);

